import { EmptyState, FlexColumn, LabeledInput, Loading } from '@gorila-shared-ui/components';
import { StyledDivider } from 'baseui/divider';
import { HeadingXSmall } from 'baseui/typography';
import { areEqual } from 'react-window';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { editingLiveStatusSettingsState, loadingLiveStatusSettingsState } from '../../../storage/settings';
import { LiveStatusConfig } from '../../../types/liveStatusConfig';

export function LiveStatusSettingsList() {
  const { css, theme } = useStyles();
  const loadingLiveStatusSettings = useRecoilValue(loadingLiveStatusSettingsState);
  const [liveStatusSettings, setLiveStatusSettings] = useRecoilState(editingLiveStatusSettingsState);

  const onChange = (minutes: number, liveStatusStting: LiveStatusConfig) => {
    if (!liveStatusSettings) return;
    const index = liveStatusSettings?.findIndex((setting) => areEqual(setting, liveStatusStting));
    if (index === undefined || index === -1) return;
    setLiveStatusSettings((prev) => {
      const newLiveStatusSetting = { ...prev![index] };
      newLiveStatusSetting.minutes = minutes;
      const newLiveStatusSettings = [...prev!];
      newLiveStatusSettings[index] = newLiveStatusSetting;
      return newLiveStatusSettings;
    });
  };

  return (
    <FlexColumn
      gap={theme.sizing.scale700}
      classNames={css({ flex: 1, overflow: 'auto', paddingRight: theme.sizing.scale600 })}
    >
      {!liveStatusSettings?.length && !loadingLiveStatusSettings && (
        <EmptyState title="No cuentas con ninguna configuracion editable" />
      )}
      {!liveStatusSettings && loadingLiveStatusSettings && <Loading />}
      {liveStatusSettings && (
        <>
          {!!liveStatusSettings.length &&
            liveStatusSettings.map((liveStatusSetting, index) => (
              <div key={index}>
                <FlexColumn gap={theme.sizing.scale300}>
                  <HeadingXSmall margin={0}>{liveStatusSetting.label}</HeadingXSmall>
                  <div className={css({ marginBottom: theme.sizing.scale300 })}>
                    <LabeledInput
                      label="Minutos:"
                      value={liveStatusSetting.minutes}
                      type="number"
                      onChange={(minutes) => onChange(+minutes, liveStatusSetting)}
                      min={1}
                    />
                  </div>
                </FlexColumn>
                {index !== liveStatusSettings.length - 1 && (
                  <StyledDivider
                    $size="cell"
                    style={{ width: '100%', marginBottom: 0 }}
                  />
                )}
              </div>
            ))}
        </>
      )}
    </FlexColumn>
  );
}
